import { FC } from "react";
import { Card } from "react-bootstrap";
import { HTMLElement } from "../../../common/HTMLElement";
import Link from "../../../common/Link";
import { ICategoryArticle } from "../../../helpers/interfaces/ranking";
import "./Article.css";

interface IArticleProps {
  article: ICategoryArticle;
}
export const Article: FC<IArticleProps> = (props) => {
  const { article } = props;
  return (
    <Card className="mb-4">
      <div className="card-container d-flex flex-column flex-sm-row">
        <div className="article-img-container my-auto">
          <Card.Img variant="left" className="article-img" src={article.img1} />
        </div>
        <Link className="h-100" href={"/articolo/" + article.id} title={"Leggi la notizia " + article.titolo}>
          <Card.Body className="py-md-0 py-sm-2 px-3">
            <HTMLElement as="h4" html={article.titolo} className="article-title mb-3" />
            <Card.Subtitle as="h6" className="article-subtitle my-2">
              {article.dataPubblicazioneData} - <span className="article-author">{article.nomeAutore}</span></Card.Subtitle>
            <HTMLElement as={"div"} html={article.articoloBreve} className="article-text card-text" />
          </Card.Body>
        </Link>
      </div>
    </Card>
  );
};
